import { render, staticRenderFns } from "./myreview-table.vue?vue&type=template&id=2e52b58b&scoped=true&"
import script from "./myreview-table.vue?vue&type=script&lang=js&"
export * from "./myreview-table.vue?vue&type=script&lang=js&"
import style0 from "./myreview-table.vue?vue&type=style&index=0&id=2e52b58b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52b58b",
  null
  
)

export default component.exports